/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../clients/axios.ts";
import type { RequestConfig, ResponseErrorConfig } from "../../../clients/axios.ts";
import type { DeleteApiTracksIdMutationResponse, DeleteApiTracksIdPathParams, DeleteApiTracksId400, DeleteApiTracksId401, DeleteApiTracksId403, DeleteApiTracksId404, DeleteApiTracksId500 } from "../../types/DeleteApiTracksId.ts";
import { deleteApiTracksIdMutationResponseSchema } from "../../zod/TracksSchemas/deleteApiTracksIdSchema.ts";

function getDeleteApiTracksIdUrl({ id }: { id: DeleteApiTracksIdPathParams["Id"] }) {
  const res = { method: 'DELETE', url: `/api/tracks/${id}` as const }  
  return res
}

/**
 * @summary Удаление трека по идентификатору
 * {@link /api/tracks/:Id}
 */
export async function deleteApiTracksId({ id }: { id: DeleteApiTracksIdPathParams["Id"] }, config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<DeleteApiTracksIdMutationResponse, ResponseErrorConfig<DeleteApiTracksId400 | DeleteApiTracksId401 | DeleteApiTracksId403 | DeleteApiTracksId404 | DeleteApiTracksId500>, unknown>({ method : "DELETE", url : getDeleteApiTracksIdUrl({ id }).url.toString(), ... requestConfig })  
  return deleteApiTracksIdMutationResponseSchema.parse(res.data)
}